<template id="unsaved-changes-dialog-content">
	<v-alert
		class="warning"
		border="left"
		colored-border
		icon="mdi-alert-rhombus">
		Leaving now will discard all unsaved changes to the current profile.
	</v-alert>
</template>

<script>
	export default {
		name: 'unsaved-changes-dialog'
	}
</script>